import React, { Suspense } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FiletypePdf } from "react-bootstrap-icons";
import { Await, useRouteLoaderData, useLoaderData } from "react-router-dom";
import LoadingIndicator from "../components/LoadingIndicator";
import { ModulePage } from "../components/pageSections";
import BlogPost from "../components/welcome/BlogPost";
import LatestDataHeader from "../components/welcome/LatestDataHeader";
import LatestDataRow from "../components/welcome/LatestDataRow";

export default function Welcome() {
    const { userInfo, radios } = useRouteLoaderData("root");
    const { latestBlogs } = useLoaderData();

    const renderBlogPosts = resolvedBlogs => {
        const blogs = Array.isArray(resolvedBlogs) ? resolvedBlogs : [];

        return blogs
            .filter(blog => blog?.documentId && blog?.Title)
            .map(blog => (
                <BlogPost
                    key={blog.id ?? blog.documentId}
                    img={blog?.Banner?.url ? `${process.env.REACT_APP_WEBSITE_URL_BACKEND}${blog.Banner.url}` : undefined}
                    title={blog.Title}
                    datePosted={blog.createdAt}
                    author={blog.Author}
                    id={blog.documentId}
                />
            ));
    };

    return (
        <ModulePage>
            <Row className="bg-white p-2 py-3">
                <h2>
                    Welcome{" "}
                    <Suspense>
                        <Await resolve={userInfo}>{resolvedUser => <span className=" fw-bold">{resolvedUser.data.greeting_name}</span>}</Await>
                    </Suspense>
                </h2>
                <Col xs={12}>
                    <h5 className="fw-bold mt-4 mb-4">To get you going</h5>
                    <p>Do you need some help to get started? We got some documents for you!</p>
                    <ul className="ms-3 mt-1 ">
                        <li>
                            RadioAnalyzer Definition{" "}
                            <a href="https://radioanalyzer.com/pdf/Definitions.pdf" target="_blank" rel="noreferrer">
                                <FiletypePdf className="fs-3 text-danger-emphasis pe-auto" />
                            </a>
                        </li>
                        <li className="my-1">
                            Music Score and Burn{" "}
                            <a href="https://radioanalyzer.com/pdf/Music_Score_and_Burn.pdf" target="_blank" rel="noreferrer">
                                <FiletypePdf className="fs-3 text-danger-emphasis pe-auto" />
                            </a>
                        </li>
                        <li>
                            Custom PLAP Workflow{" "}
                            <a href="https://radioanalyzer.com/pdf/Custom_PLAP_Workflow.pdf" target="_blank" rel="noreferrer">
                                <FiletypePdf className="fs-3 text-danger-emphasis pe-auto" />
                            </a>
                        </li>
                    </ul>
                    <span>
                        If you have any technical questions or you would like some help, please reach us at{" "}
                        <a className="text-dark fw-bold " href="mailto:support@radioanalyzer.com" target="_blank" rel="noreferrer">
                            support@radioanalyzer.com
                        </a>
                    </span>
                </Col>
            </Row>
            <hr className="m-2" />
            <Row className="bg-white p-2 py-3">
                <Suspense
                    fallback={
                        <Col>
                            <h5 className="fw-bold text-center">Your latest data</h5>
                            <LoadingIndicator width={75} />
                        </Col>
                    }>
                    <Await resolve={radios}>
                        {resolvedRadios => (
                            <>
                                {resolvedRadios.data.some(x => x.stream) && (
                                    <Col xs={12} xl={6}>
                                        <h5 className="fw-bold">Your latest Stream data</h5>
                                        <LatestDataHeader />
                                        <Container fluid className=" mh-500 overflow-y-auto">
                                            {resolvedRadios.data
                                                .filter(x => x.stream)
                                                .map(x => (
                                                    <LatestDataRow key={x.radio_id} radio={x} dataType={1} />
                                                ))}
                                        </Container>
                                    </Col>
                                )}
                                <hr className="m-2 my-3 d-xl-none" />
                                {resolvedRadios.data.some(x => x.ppm) && (
                                    <Col>
                                        <h5 className="fw-bold">Your latest PPM data</h5>
                                        <LatestDataHeader />
                                        <Container fluid className=" mh-500 overflow-y-auto">
                                            {resolvedRadios.data
                                                .filter(x => x.ppm)
                                                .map(x => (
                                                    <LatestDataRow key={x.radio_id} radio={x} dataType={2} />
                                                ))}
                                        </Container>
                                    </Col>
                                )}
                            </>
                        )}
                    </Await>
                </Suspense>
            </Row>
            <hr className="m-2" />
            <Row className="bg-white p-2 py-3">
                <h2 className="text-uppercase text-center mb-4">What's New?</h2>
                <Col xl={12}>
                    <Row className="row-cols-1 row-cols-md-2 row-cols-xl-3 text-center gy-4">
                        <Suspense>
                            <Await resolve={latestBlogs}>{resolvedBlogs => renderBlogPosts(resolvedBlogs)}</Await>
                        </Suspense>
                    </Row>
                </Col>
            </Row>
        </ModulePage>
    );
}
